<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">STOCK IN DETAIL</li>
        </ol>
        <div class="x_header">
            <div class="pull-left">
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print"><i class="fa fa-print"></i> {{$t('print')}}</button>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="toolbar">
                        <div class="form-group">
                            <input type="date" class="form-control form-control-sm" v-model="query.FromDate" />
                        </div>
                        <div class="form-group">
                            <input type="date" class="form-control form-control-sm" v-model="query.ToDate" />
                        </div>
                        <div class="form-group">
                            <select class="form-control form-control-sm" v-model="query.GroupBy">
                                <option value="ItemCode">Group By Item</option>
                                <option value="Vendor">Group By Vendor</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search"></i> Search</button>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                            <tr class="toUpper" style="font-weight: normal;">
                                <th class="text-center">{{$t('no')}}</th>
                                <th>{{$t('date')}}</th>
                                <th>{{$t('stock_in_no')}}</th>
                                <th>{{$t('item_name')}}</th>
                                <th>Vendor</th>
                                <th>{{$t('branch')}}</th>
                                <th>{{$t('type')}}</th>
                                <th>{{$t('ref_num')}}</th>
                                <th>{{$t('uom')}}</th>
                                <th class="text-right">{{$t('qty')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(gp,gin) in records">
                                <tr :key="gin">
                                    <th colspan="10">{{gp.TitleName}}</th>
                                </tr>
                                <tr v-for="(ret, index) in gp.StockInLineListDatas" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{$format(ret.DateApproved,'DD/MM/YYYY')}}</td>
                                    <td>{{ret.StockinCode}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td>{{ret.VendorName}}</td>
                                    <td>{{ret.BranchName}}</td>
                                    <td>{{ret.DocSource}}</td>
                                    <td>{{ret.DocSourceNo}}</td>
                                    <td class="text-right">{{ret.UomName}}</td>
                                    <td class="text-right">{{ret.QuantityIn}}</td>
                                </tr>
                                <tr v-if="isShowFooter" :key="'total'+gin" class="table-active">
                                    <th colspan="9" class="text-right">Total</th>
                                    <th class="text-right">{{$number(gp.TotalQty,'0,0.[00]')}}</th>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                query: {
                    GroupBy: 'ItemCode',
                    FromDate: this.$startOfMonth(),
                    ToDate: this.$endOfMonth(),
                    CompanyId: this.$store.state.company.Id
                },
                records: [],
                isShowFooter: false
            }
        },
        created() {
            this.toList();
        },
        methods: {
            toList() {
                var loading = this.$loading.show();
                this.records = [];
                this.$api().post("report/stockin/detail", this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.isShowFooter = this.query.GroupBy == 'ItemCode' ? true : false;
                        this.records = res.data.Json.StockInDetails;
                    }
                }).finally(() => { loading.hide(); });
            },
            print() {
                window.open(
                    "/print/detail/stockin?from=" + this.query.FromDate + "&to=" + this.query.ToDate + '&gby=' + this.query.GroupBy + '&CompanyId=' + this.$store.state.company.Id,
                    "_blank"
                );
            }
        }
    }
</script>